import { gql, useQuery } from "@apollo/client"
import { enablePreview, client } from "../../graphql/contentful/client"
import { CaseModel } from "../../components/contentful/models"
import { ContentfulEntryTypeName } from "../../components/contentful/entries"
import { RICH_TEXT_CONTENT } from "../news/useArticle"

export interface CasePageQuery {
  caseCollection: {
    items: CaseModel<ContentfulEntryTypeName>[]
  }
}

export const QUERY_CASE_PAGE = gql`
query getCasePage($slug: String!, $preview: Boolean) {
  caseCollection(where: { slug: $slug }, limit: 1, preview: $preview) {
    items {
      sys {
        id
      }
      slug
      metadata {
        title
        description
        type
        tags
        relatedLinks
      }
      color
      title
      description
      hero {
        sys {
          id
        }
        showTitle
        title
        subtitle
        image {
          sys {
            id
          }
          url(transform: { format: WEBP, width: 2400, quality: 70 })
        }
      }
      ${RICH_TEXT_CONTENT}
    }
  }
}
`
export function useCasePage(slug: string) {
  const { data, error, loading } = useQuery<CasePageQuery>(QUERY_CASE_PAGE, {
    client: client,
    variables: {
      slug,
      preview: enablePreview,
    },
  })

  const casePage = data?.caseCollection.items[0]

  return {
    casePage,
    error,
    loading,
    query: QUERY_CASE_PAGE,
  }
}
